
import React from 'react';
import { useSelector } from 'react-redux';

function SummaryCards() {
  const { totalStocks, lowStocks, returnsStoks, loading } = useSelector((state) => state.stockDashboard);

  if (loading && !totalStocks && !lowStocks && !returnsStoks) {
    return <p>Loading...</p>;
  }

  const cards = [
    { title: 'Total Stocks', value: totalStocks },
    { title: 'Low Stocks', value: lowStocks },
    { title: 'Returns', value: returnsStoks },
  ];

  return (
    <div style={{ display: 'flex', gap: '20px' }}>
      {cards.map((card, i) => (
        <div
          key={i}
          style={{
            padding: '1px 20px 20px 20px',
            background: '#e9f2ff',
            borderRadius: '16px',
            flex: 1,
          }}
        >
          <h4>{card.title}</h4>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 style={{ margin: 0 }}>{card.value}</h2>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SummaryCards;
